import { render, staticRenderFns } from "./Popup-item.vue?vue&type=template&id=265fa4da"
import script from "./Popup-item.vue?vue&type=script&lang=js"
export * from "./Popup-item.vue?vue&type=script&lang=js"
import style0 from "./Popup-item.vue?vue&type=style&index=0&id=265fa4da&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports